import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  email: "",
  userData: "No Data",
};

export const loginSlice = createSlice({
  name: "loginReducer",
  initialState,
  reducers: {
    loginApi: (state, action) => {
      state.userData = action.payload;
    },
  },
});
// Action creators are generated for each case reducer function
export const { increment, decrement, incrementByAmount, loginApi } =
  loginSlice.actions;

export default loginSlice.reducer;
